import { render, staticRenderFns } from "./CampaignFeedItem.vue?vue&type=template&id=58f42c37&scoped=true&"
import script from "./CampaignFeedItem.vue?vue&type=script&lang=js&"
export * from "./CampaignFeedItem.vue?vue&type=script&lang=js&"
import style0 from "./CampaignFeedItem.vue?vue&type=style&index=0&id=58f42c37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f42c37",
  null
  
)

export default component.exports